import React, { useEffect } from 'react';

import { type Venue } from 'generated/graphql';
import { sanitiseUrlParam } from 'utils';
import { useParams, useNavigate, Outlet } from 'react-router-dom';
import { useVenueContext } from './Main';

interface Props {
  isLoading?: boolean;
  allVenues?: Venue[];
  currentVenue?: Venue;
}

const SingleVenue: React.FC<Props> = ({ isLoading, allVenues, currentVenue }) => {
  const { venueId } = useParams();
  const navigate = useNavigate();

  const sanitisedVenueId = sanitiseUrlParam(venueId);

  useEffect(() => {
    const invalidVenueId =
      sanitisedVenueId && allVenues?.length && !allVenues.find((venue) => venue.hashedId === sanitisedVenueId);

    if ((!sanitisedVenueId && allVenues?.length) || invalidVenueId) {
      navigate(`/venue/${allVenues[0].hashedId}`);
    }
  }, [sanitisedVenueId, allVenues, navigate]);

  useEffect(() => {
    if (sanitisedVenueId && !currentVenue && !isLoading) {
      navigate(`/`);
    }
  }, [currentVenue, sanitisedVenueId, navigate, isLoading]);

  return <Outlet context={useVenueContext()} />;
};

export default SingleVenue;
